/**
 * Role vindo do login (userData) ou fallback userRole no localStorage (sessões antigas).
 */
export function normalizeRole(userData) {
  const r =
    userData?.role ??
    (typeof localStorage !== 'undefined' ? localStorage.getItem('userRole') : '') ??
    '';
  return String(r).trim().toLowerCase();
}

export function isAdminOrSuperAdmin(userData) {
  const r = normalizeRole(userData);
  return r === 'admin' || r === 'super_admin';
}

export function getBearerHeaders() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  if (!token || !String(token).trim()) return null;
  const t = String(token).trim();
  // Authorization (sessão JWT) + X-Access-Token: alguns proxies removem só Authorization
  return {
    Authorization: `Bearer ${t}`,
    'X-Access-Token': t
  };
}
